import { Property } from "./interfaces";

export const codComplicacion: Property = {
    title: "Código de Complicación",
    type: "string"
}